<template>
    <div class="title_bar">
        <div class="box_title">
            <div class="box_title_left">
                {{ name }}
            </div>
            <div class="box_title_right">
               <span class="el-icon-location-outline"></span> 当前位置:  <router-link to="/"> 首页 </router-link> /  {{ name }} 
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: String
        }
    }
</script>

<style lang="scss" scoped>
.title_bar {
    width: 1200px;
    margin: 20px auto;
    .box_title {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 4px solid #fff;
        margin: 20px 0;
        font-size: 16px;
        .box_title_left {
            font-size: 24px;
            font-weight: bold;
        }
        .box_title_right {
            font-size: 14px;
        }
    }
}
</style>